module Sm.Service.Backup

open System
open Fable.Core.JsInterop

open Sm.Core.Interop

open Sm.Service.Database
open Sm.Service.Storage
open Sm.Service.Repository
open Sm.Service.Session

let export ctx = promise {
    let! recordStore = ctx.Environment.DatabaseName |> readRecordStore
    let! records = recordStore.getAll() |> result<obj array>

    let entries =
        records
        |> Seq.choose (Document.parse ctx.Environment.ClientId)
        |> Seq.choose (fun doc ->
            let hasTextfield = doc.Fields.ContainsKey(Document.TextField)

            let isJournal =
                let (CodeValue journal) = JournalCode

                match Id.parse doc.Id with
                | Some (CodeValue actual, _) when actual = journal -> true
                | _ -> false

            if hasTextfield && isJournal then
                Some (createObj [
                    "id" ==> doc.Id
                    "fields" ==> Document.serializeFields Guid.Empty doc.Fields
                ])
            else None
        )
        |> Seq.toArray

    return Json.stringify entries
}

let import data ctx =
    let updates =
        data
        |> Json.parseArray
        |> Seq.choose (Document.parse ctx.Environment.ClientId)
        |> Seq.collect (fun x -> seq {
            for KeyValue(name, reg) in x.Fields do
                {
                    Clock = reg.Clock
                    Client = ctx.Environment.ClientId
                    Target = {
                        Id = x.Id
                        Field = name
                        Value = reg.Value
                    }
                }
        })

    ctx.Repository.Merge(updates)
